/**
 * @author Hideo Yamada
 * @description https://marvelapp.com/prototype/1152g05j/screen/67851883
 */

import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import findIndex from 'ramda/src/findIndex';
import Button from '@components/@core/AnimatedButton';
import EditDropdown from '@components/EditDropdown';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import Tab from '@components/@core/Tab';
import CommunityActions from '~/actions/community';
import { CONNECTION_MOBILE_TABLIST } from '~/services/constants';
import Recommended from './Recommended';
import People from './People';
import Companies from './Companies';
import ReceivedRequestes from './ReceivedRequestes';
import SentRequests from './SentRequests';

const Connections = ({ user, connections, onLogin }) => {
    const authenticated = useSelector((state) => state.app.token);
    const loginUser = useSelector((state) => state.app.user?.community_user);

    const [active, setActive] = useState('people');

    const activeConnections = loginUser?.connections?.active_user_connections || [];
    const connected = findIndex((x) => x.connector?.user_id === user?.id, activeConnections) > -1 || loginUser?.id === user?.id;

    const dispatch = useDispatch();
    const handleGetConnections = () => {
        if (authenticated) {
            const payload = { user_id: user.id };
            dispatch(CommunityActions.getcommunityconnectionsRequest(payload));
        }
    };

    useEffect(() => {
        handleGetConnections();
    }, []);

    return (
        <ErrorBoundary className="individual-profile-connections">
            <Helmet>
                <title>
                    {user.first_name} {user.last_name} Industry Connections
                </title>
                <meta name="description" content="" />
            </Helmet>
            <div className="connections-wrapper mb-3">
                {authenticated ? (
                    connected ? (
                        <>
                            <div className="connections-header pb-2">
                                <p className="dsl-b22 bold my-2">Recommended Connections</p>
                            </div>
                            <Recommended user={user} connections={connections?.recommended} />
                        </>
                    ) : (
                        <>
                            <div className="connections-header pb-2">
                                <p className="dsl-b22 bold my-2">Mutual Connections</p>
                            </div>
                            <People connections={connections?.active_user_connections} />
                        </>
                    )
                ) : (
                    <div className="d-flex login-content text-center">
                        <p className="dsl-b14 mb-0">{`Please, Login to see ${user?.first_name}'s connections and gain the ability to connect and get in touch with them.`}</p>
                        <Button className="mt-2" name="Login" type="medium" onClick={() => onLogin()} />
                    </div>
                )}
            </div>

            {authenticated && connected && (
                <div className="connections-wrapper">
                    <div className="connections-header pb-2">
                        <p className="dsl-b22 bold my-2">My Connections</p>
                        <EditDropdown options={['Edit']} onChange={() => {}} />
                    </div>
                    <ResponsiveTabs className="p-2" active={active} data={CONNECTION_MOBILE_TABLIST} onTab={(e) => setActive(e.id)} />
                    <Tab eventKey="people" active={active} title="People">
                        <People connections={connections?.active_user_connections} />
                    </Tab>
                    <Tab eventKey="companies" active={active} title="Companies">
                        <Companies companies={connections?.active_company_connections} user={user} />
                    </Tab>
                    <Tab eventKey="received" active={active} title="Received Requests">
                        <ReceivedRequestes user={user} requests={connections?.pending_connections_received} />
                    </Tab>
                    <Tab eventKey="sent" active={active} title="Sent Requests">
                        <SentRequests user={user} requests={connections?.pending_connections_sent} />
                    </Tab>
                </div>
            )}
        </ErrorBoundary>
    );
};

Connections.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.number,
    }),
    connections: PropTypes.shape({
        active_connections: PropTypes.array,
        followers: PropTypes.array,
        following_companies: PropTypes.array,
        following_users: PropTypes.array,
        pending_connections: PropTypes.array,
    }),
};

Connections.defaultProps = {
    user: {
        id: 0,
        name: '',
    },
    connections: {
        active_connections: [],
        followers: [],
        following_companies: [],
        following_users: [],
        pending_connections: [],
    },
};

export default Connections;
